import Vue from 'vue'
import Router from 'vue-router'
import index from './views/index.vue'
import copywriting from './views/copywriting.vue'
import history from './views/history.vue'
import order from './views/order.vue'
import point from './views/point.vue'
import account from './views/account.vue'
import microvideo from './views/microvideo.vue'
import face from './views/face.vue'
import digital from './views/digital.vue'
import clone from './views/clone.vue'
import customized from './views/customized.vue'
import about from '@/components/about/index.vue'
import invite from '@/components/invite/index.vue'
import member from '@/components/member/index.vue'
import videoplaym from '@/components/videoplay/videoplaym.vue'
import feedback from '@/components/feedback'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/copywriting/:id',
      name: 'copywriting',
      component: copywriting
    },
    {
      path: '/history/:type?',
      name: 'history',
      component: history
    },
    {
      path: '/order',
      name: 'order',
      component: order
    },
    {
      path: '/point',
      name: 'point',
      component: point
    },
    {
      path: '/account',
      name: 'account',
      component: account
    },
    {
      path: '/microvideo',
      name: 'microvideo',
      component: microvideo
    },
    {
      path: '/face',
      name: 'face',
      component: face
    },
    {
      path: '/digital',
      name: 'digital',
      component: digital
    },
	{
	  path: '/clone',
	  name: 'clone',
	  component: clone
	},
	{
	  path: '/customized',
	  name: 'customized',
	  component: customized
	},
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/invite',
      name: 'invite',
      component: invite
    },
    {
      path: '/member',
      name: 'member',
      component: member
    },
    {
      path: '/videoplaym/:id?',
      name: 'videoplaym',
      component: videoplaym
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
  ]
})
